<template>
<div>
<section class="page-title">        
    <v-img 
        v-if="this.$vuetify.breakpoint.lg"
        height="330px"        
        :src="require('@/Content/images/banner2.png')"
        class="white--text"
        gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
        max-width="100%"  
               
      >
      <div class="center">
        <p class="label-planos" >Apaixonados Saúde Pet</p>
        <h1 class="the-title"><span>Amar</span> também é prevenção</h1>
        <p style="color:#666">O plano de saúde que seu pet merece!</p>
        <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
    </div>
    </v-img>
    <v-img 
        v-else
        height="300"        
        class="white--text"
        gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
        max-width="100%"  
        position="center top"        
      >
      <div class="center">
        <p class="label-planos" >Pessoa Física</p>
        <h1 class="the-title"><span>Soluções</span> para o seu Pet</h1>
        <p style="color:#7593b4">Garanta o bem estar do seu bichinho!</p>
        <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
    </div>
    </v-img>
</section>


<section class="page-content center">
    <p class="title-label">O Apaixonados Saúde Pet</p>
    <p>Plano de saúde veterinário da maior rede de clínicas populares do Brasil, a Apaixonados por Quatro Patas. Com mais de 50 clínicas em todas as regiões do estado do Rio, as Apaixonados estão chegando também ao estado de São Paulo e em breve a Minas Gerais.</p>
    <p>Uma rede de cobertura para o plano de saúde do seu pet que não para de crescer.</p>    
    <p class="title-label">Porque fazer um plano de saúde Apaixonado Saúde Pet para o seu pet?</p>
    <p>Todo plano de saúde, até mesmo para humanos, é antes de tudo uma medida de prevenção. No caso de um plano de saúde pet, você nunca sabe quando o seu animal vai precisar.Com o Apaixonados Saúde Pet, o seu bichinho tem atendimento de emergência, consultas, exames, castrações, cirurgias, internações, tudo coberto pelo plano, respeitando as carências pré-estabelecidas por cada modalidade de contrato.</p>    
    <p class="title-label">Nossos diferenciais</p>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>REDE PRÓPRIA COM MAIS DE 50 CLÍNICAS.</strong></p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>ATENDIMENTO SEMPRE PERTO DE VOCÊ.</strong></p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>A MELHOR RELAÇÃO PREÇO/COBERTURA.</strong></p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>ATENDIMENTO VETERINÁRIO DE QUALIDADE RECONHECIDA.</strong></p>
    </div>    
    <!-- <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.orale.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
    <p class="title-label">Carências</p>
    <p>Somente alguns planos da Orale possuem carências. Carência é o prazo ininterrupto, em que o beneficiário não goza do direito de utilizar da cobertura do plano contratado, sendo este prazo contado da data de aceitação da Proposta de Adesão, que está entendida data de início de vigência do beneficiário.</p> -->
    <!-- <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
        <tr>
            <th></th>
            <th colspan="1">Carências</th>
        </tr>
        <tr class="mini-header">
            <td>Procedimentos</td>

            <td class="carencia">Plano Individual/Familiar</td>
        </tr>
        <tr>
            <td>Consulta de Urgência</td>

            <td class="carencia">24 horas</td>
        </tr>
        <tr>
            <td>Consulta inicial, Radiologia, Prevenção</td>

            <td class="carencia">30 dias</td>
        </tr>
        <tr>
            <td>Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>

            <td class="carencia">60 dia</td>
        </tr>
        <tr>
            <td>Endodontia</td>

            <td class="carencia">120 dias</td>
        </tr>
        <tr>
            <td>Prótese</td>

            <td class="carencia">180 dias</td>
        </tr>
    </table> --> 
    <div class="contrataragora"> 
    <v-fade-transition mode="out-in">    
    <div class="exibelocalizacao" v-if="exibeLocalizacao"> 
    <div class="planos-wrapper">
    <p class="planos-title">Local de utilização</p>
    <v-layout align-center>
    <v-flex xs12 sm12>
        <v-card
            flat
            max-height="400px"
            max-width="600px"
            class="mx-auto localizacao"
            style="border: 1px solid; border-color: #004899;border-radius: 10px;">
            <v-card-text>
                <v-container grid-list-md>
                <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm12 lg10>
                <v-select
                id="comboOrgao"               
                v-model="abrangenciaAgrupamento"
                item-value="abrangenciaId"
                item-text="agrupamento"
                :items="agrupamentosUF"
                label="Local de Utilização"                
                ></v-select>
                </v-flex>
                <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm6 md6 lg6 >
                <v-btn
                style="border-radius: 6px;"
                large                
                dark
                @click="controlaExibicaoPlanos()"
                color="#004899"
                >Consultar Planos</v-btn>
                </v-flex>
                </v-layout>
                </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
    </v-layout>
    </div>
    </div>
    <div class="exibeplanos" v-else>    
    <div class="planos-wrapper">
    <p class="planos-title">Região:  {{this.nomeAgrupamento}}
        <v-btn
        icon        
        dark
        @click.prevent="exibeLocalizacao = !exibeLocalizacao"
        color="#004899"
        >
        <v-icon style="margin-right: 0%;">cached</v-icon>
        </v-btn>
        </p>
        <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
        <v-container
            grid-list-md
            >
        <v-layout row wrap justify-center>
                <v-flex
                v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md12 lg4              
                >
                <div class="list-planos">                    
                    <div class="item">
                        <!-- <h6 class="dePara">De</h6>
                        <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                        <h6 class="dePara">Por</h6> -->
                        <p class="price"><span>R$</span> {{plano.value}}<br><span>(Por pet)</span></p>                                                                          
                                <p class="cobertura"><span>{{plano.area_atuacao}}</span><b>{{plano.qualificacao}}</b></p>                                               
                        <div class="boleto"><i class="fas fa-barcode"></i>{{plano.name}}</div>
                        <a @click="contratoPF(plano)" class="button">Contratar plano</a>
                    </div>
                </div>
                </v-flex>            
            </v-layout>
        </v-container>        
    </div>
    </div>
    </v-fade-transition>
</div>
</section>
<!-- <v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) cliente,</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#004899">Orale</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#004899">Termo de Privacidade, <a href="https://Orale.intelite.com.br/contratosOrale/docs/Politica_de_Privacidade_Orale_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#004899"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da Orale.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn @click="confirmaPlano()" color="#004899" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog> -->
<Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
export default {
    components: {Snackbar},
data(){
        return{
            dialog: false,
            abrangenciaAgrupamento: '',
            exibeLocalizacao: true,
            nomeAgrupamento: '',
            planos: [],
            vendedor: [],
            planoSelecionado: [],
            abrangencias: [],
            agrupamentosUF: [],
            abrangenciaUF: '',
            contrataccept: false
    };
  },
 /*  watch: {
    'estado': function () {
      this.cidades = brasil[this.estado].cidades
    }
  }, */
    
    mounted : function(){    
      localStorage.clear()
      sessionStorage.clear()  
      this.pegaParametrosUrl()  
      this.$store.dispatch('ExibeToolbar')
      this.$store.dispatch('ExibeFooter')
      this.exibeLocalizacao = true;
      this.$store.dispatch('Logar')
      this.carregaAgrupametos()
    },
    methods: {
        scrollToClass(className) {
            // Get the first element with the given class name
            let el = this.$el.querySelector(className)
            // Get the bounding rectangle so we can get the element position position
            let rect = el.getBoundingClientRect()
            // Scroll to the element (using x and y axis)
            window.scrollTo(rect.left, rect.top)
            },
            scrollbotton(){
            window.scrollTo(0, 3000)
        },
        async controlaExibicaoPlanos(){
            if(this.abrangenciaAgrupamento == '')
            {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Selecione o local onde deseja utilizar o plano!","ATENÇÃO")
            }
            else{
                for(var i=0; i<this.agrupamentosUF.length; i++) {
                    if(this.agrupamentosUF[i].abrangenciaId === this.abrangenciaAgrupamento) {
                        this.nomeAgrupamento = this.agrupamentosUF[i].agrupamento
                    }
                }
/*             if(this.nomeAgrupamento.includes("SP") || this.nomeAgrupamento.includes("MG") || this.nomeAgrupamento.includes("RO"))
            {
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
                return
            }    
            else{ */
            await axios.get(`${baseApiUrl}Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["${this.abrangenciaAgrupamento}"]}},{"qualificacao":{"inq":["Individual","Familiar"]}},{"publico":"Pessoa Física"},{"exibicao":{"inq":["EXTERNA","AMBAS"]}}]},"order":"name ASC"}`).then(res => {        
            if(res.data != null){      
                if (this.vendedor.planosPermitidos) {
                    if (this.vendedor.planosPermitidos.length == 0) {
                    this.planos = res.data
                    } else {
                        for (let i = 0; i < this.vendedor.planosPermitidos.length; i++) {
                            for (let j = 0; j < res.data.length; j++) {
                                if (this.vendedor.planosPermitidos[i] == res.data[j].id) {
                                    this.planos.push(res.data[j])
                                }
                            }
                        }
                    }
                } else {
                    this.planos = res.data
                }
            }              	
			})    
            this.exibeLocalizacao = false;
            }
            
        
        },
        /* contratoPF(plano){
            this.dialog = true
            
        }, */
        contratoPF(plano){

            localStorage.clear()
            sessionStorage.clear()
            this.planoSelecionado = plano
            this.$store.dispatch('planosPF', this.planoSelecionado)
            localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))   
            if(this.vendedor != '')
            sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor))        
            this.$router.push({ path: '/contratopf' })

        },
        calculaDesconto(plano){
            var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
            //desconto = desconto.replace('.','.')
            return desconto.toFixed(2).replace('.',',')
        },
        async carregaAgrupametos(){
        this.abrangenciaOrgao = ''
        await axios.get(`${baseApiUrl}AgrupamentoUFs?filter[where][status]=Ativo`).then(res => {        
            if(res.data != null){      
            this.agrupamentosUF = res.data.sort(this.compare)
            }
        })

        },
        compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const agrupamentoA = a.agrupamento;
        const agrupamentoB = b.agrupamento;

        let comparison = 0;
        if (agrupamentoA > agrupamentoB) {
            comparison = 1;
        } else if (agrupamentoA < agrupamentoB) {
            comparison = -1;
        }
        return comparison;
        },
    async pegaParametrosUrl(){
      var params = window.location.search.substring(1).split('&');
      if(params[0] != ''){
      //Criar objeto que vai conter os parametros
      var paramArray = {};

      //Passar por todos os parametros
      for(var i=0; i<params.length; i++) {
          //Dividir os parametros chave e valor
          var param = params[i].split('=');

          //Adicionar ao objeto criado antes
          paramArray[param[0]] = param[1];
          }      
      if(paramArray['vendedor'])
      {
      await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {        
            if(res.data != null){
            //console.log(res.data[0])
            this.vendedor = res.data[0]           
            }              	
			}) 
        }
      }
    }
    }
}
</script>

<style>

    .localizacao{
        border: 1px solid;
        border-color: #004899;
    }
</style>
